import { gql } from "@apollo/client";

export const getLensCategoryList = gql`
    query getLensCategoryList {
        getLensCategoryList {
            lensCategoryList {
                parentLensCategoriesList {
                    id
                    parentId
                    displayName
                    deprecated
                }
                subLensCategoriesList {
                    id
                    parentId
                    displayName
                    deprecated
                }
            }
        }
    }
`;
